module.exports = __webpack_public_path__ + "static/media/banner-4.d53c94ea.jpg";